import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Delete = function Delete(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.298 12.6992L7.99628 9.41797L4.70135 12.6992L3.29999 11.2979L6.58124 8.00293L3.29999 4.70117L4.70135 3.2998L7.99628 6.58105L11.298 3.2998L12.6994 4.70117L9.41815 8.00293L12.6994 11.2979L11.298 12.6992Z",
    clipRule: "evenodd"
  })));
};